export const transcription = {
    messages: [
        {
            "id": "5829879234035712",
            "text": "Call is now being recorded, Parker scarves, how may I help you?",
            "from": {},
            "startTime": "2023-09-08T08:46:49.772Z",
            "endTime": "2023-09-08T08:46:53.972Z",
            "timeOffset": 0.2,
            "duration": 4.2,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "4751275062460416",
            "text": "Scarf online for my wife and it turns out they shipped the wrong color.",
            "from": {},
            "startTime": "2023-09-08T08:46:55.572Z",
            "endTime": "2023-09-08T08:46:59.072Z",
            "timeOffset": 6,
            "duration": 3.5,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5771095635656704",
            "text": "Oh I am so sorry sir.",
            "from": {},
            "startTime": "2023-09-08T08:47:00.072Z",
            "endTime": "2023-09-08T08:47:01.472Z",
            "timeOffset": 10.5,
            "duration": 1.4,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5960020098547712",
            "text": "I got it for my birthday which is tonight and now I am not 100% sure what I need to do?",
            "from": {},
            "startTime": "2023-09-08T08:47:02.972Z",
            "endTime": "2023-09-08T08:47:07.172Z",
            "timeOffset": 13.4,
            "duration": 4.2,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "6607008133545984",
            "text": "Okay let me see if I can help you.",
            "from": {},
            "startTime": "2023-09-08T08:47:07.872Z",
            "endTime": "2023-09-08T08:47:09.672Z",
            "timeOffset": 18.3,
            "duration": 1.8,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5396182898835456",
            "text": "Do you have the item number of the Parker scarf?",
            "from": {},
            "startTime": "2023-09-08T08:47:09.972Z",
            "endTime": "2023-09-08T08:47:12.372Z",
            "timeOffset": 20.4,
            "duration": 2.4,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "6447387330740224",
            "text": "I don't know.",
            "from": {},
            "startTime": "2023-09-08T08:47:13.472Z",
            "endTime": "2023-09-08T08:47:13.972Z",
            "timeOffset": 23.9,
            "duration": 0.5,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5134339613655040",
            "text": "I don't think so.",
            "from": {},
            "startTime": "2023-09-08T08:47:13.972Z",
            "endTime": "2023-09-08T08:47:14.572Z",
            "timeOffset": 24.4,
            "duration": 0.6,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5106324523450368",
            "text": "It's called The New Yorker.",
            "from": {},
            "startTime": "2023-09-08T08:47:14.572Z",
            "endTime": "2023-09-08T08:47:15.872Z",
            "timeOffset": 25,
            "duration": 1.3,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "6317487139586048",
            "text": "I think excellent.",
            "from": {},
            "startTime": "2023-09-08T08:47:15.872Z",
            "endTime": "2023-09-08T08:47:18.072Z",
            "timeOffset": 26.3,
            "duration": 2.2,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5816470245474304",
            "text": "Okay.",
            "from": {},
            "startTime": "2023-09-08T08:47:18.072Z",
            "endTime": "2023-09-08T08:47:18.472Z",
            "timeOffset": 28.5,
            "duration": 0.4,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "6547565786169344",
            "text": "What color did you want the New Yorker in?",
            "from": {},
            "startTime": "2023-09-08T08:47:18.772Z",
            "endTime": "2023-09-08T08:47:20.872Z",
            "timeOffset": 29.2,
            "duration": 2.1,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "6390913556545536",
            "text": "Blue.",
            "from": {},
            "startTime": "2023-09-08T08:47:22.072Z",
            "endTime": "2023-09-08T08:47:22.572Z",
            "timeOffset": 32.5,
            "duration": 0.5,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5483883387944960",
            "text": "The one that shift was light blue.",
            "from": {},
            "startTime": "2023-09-08T08:47:22.972Z",
            "endTime": "2023-09-08T08:47:25.272Z",
            "timeOffset": 33.4,
            "duration": 2.3,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5177097556590592",
            "text": "I wanted the darker one.",
            "from": {},
            "startTime": "2023-09-08T08:47:25.272Z",
            "endTime": "2023-09-08T08:47:26.572Z",
            "timeOffset": 35.7,
            "duration": 1.3,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5078455512465408",
            "text": "Did you want, navy blue or royal blue?",
            "from": {},
            "startTime": "2023-09-08T08:47:27.772Z",
            "endTime": "2023-09-08T08:47:29.972Z",
            "timeOffset": 38.2,
            "duration": 2.2,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "6577080801427456",
            "text": "How was the difference there?",
            "from": {},
            "startTime": "2023-09-08T08:47:31.272Z",
            "endTime": "2023-09-08T08:47:32.372Z",
            "timeOffset": 41.7,
            "duration": 1.1,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "4529884413296640",
            "text": "The royal blue is a bit brighter.",
            "from": {},
            "startTime": "2023-09-08T08:47:33.672Z",
            "endTime": "2023-09-08T08:47:35.672Z",
            "timeOffset": 44.1,
            "duration": 2,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "6298827587059712",
            "text": "That's the one I want.",
            "from": {},
            "startTime": "2023-09-08T08:47:36.872Z",
            "endTime": "2023-09-08T08:47:38.072Z",
            "timeOffset": 47.3,
            "duration": 1.2,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "4852677201887232",
            "text": "Okay, what ZIP code are you located in 1940?",
            "from": {},
            "startTime": "2023-09-08T08:47:38.972Z",
            "endTime": "2023-09-08T08:47:43.072Z",
            "timeOffset": 49.4,
            "duration": 4.1,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "6194865110253568",
            "text": "68 appears that we do not.",
            "from": {},
            "startTime": "2023-09-08T08:47:43.072Z",
            "endTime": "2023-09-08T08:47:47.272Z",
            "timeOffset": 53.5,
            "duration": 4.2,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "4783539636928512",
            "text": "I am sorry that we do have that item in stock at Karen's Boutique at the hunter mall is that close by It is, it's right by my office.",
            "from": {},
            "startTime": "2023-09-08T08:47:47.672Z",
            "endTime": "2023-09-08T08:47:55.772Z",
            "timeOffset": 58.1,
            "duration": 8.1,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "6213091718332416",
            "text": "Okay, what is your name, sir?",
            "from": {},
            "startTime": "2023-09-08T08:47:56.472Z",
            "endTime": "2023-09-08T08:47:58.672Z",
            "timeOffset": 66.9,
            "duration": 2.2,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5069230434418688",
            "text": "Charlie Johnson.",
            "from": {},
            "startTime": "2023-09-08T08:47:59.372Z",
            "endTime": "2023-09-08T08:48:00.672Z",
            "timeOffset": 69.8,
            "duration": 1.3,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "4722308267900928",
            "text": "Charlie Johnson.",
            "from": {},
            "startTime": "2023-09-08T08:48:01.372Z",
            "endTime": "2023-09-08T08:48:02.472Z",
            "timeOffset": 71.8,
            "duration": 1.1,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5577161378627584",
            "text": "Is that Jo hn?",
            "from": {},
            "startTime": "2023-09-08T08:48:02.472Z",
            "endTime": "2023-09-08T08:48:03.972Z",
            "timeOffset": 72.9,
            "duration": 1.5,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5797206251798528",
            "text": "S 0n?",
            "from": {},
            "startTime": "2023-09-08T08:48:03.972Z",
            "endTime": "2023-09-08T08:48:04.772Z",
            "timeOffset": 74.4,
            "duration": 0.8,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "4564685283393536",
            "text": "Yes, ma'am and Mr. Johnson, do you have the Parker scarf in light blue with you now?",
            "from": {},
            "startTime": "2023-09-08T08:48:05.372Z",
            "endTime": "2023-09-08T08:48:10.372Z",
            "timeOffset": 75.8,
            "duration": 5,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "4917772607029248",
            "text": "I do they shipped it to my office?",
            "from": {},
            "startTime": "2023-09-08T08:48:11.572Z",
            "endTime": "2023-09-08T08:48:13.172Z",
            "timeOffset": 82,
            "duration": 1.6,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5602383733456896",
            "text": "It just came in.",
            "from": {},
            "startTime": "2023-09-08T08:48:13.172Z",
            "endTime": "2023-09-08T08:48:14.172Z",
            "timeOffset": 83.6,
            "duration": 1,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5115483994193920",
            "text": "Not that long though.",
            "from": {},
            "startTime": "2023-09-08T08:48:14.372Z",
            "endTime": "2023-09-08T08:48:15.172Z",
            "timeOffset": 84.8,
            "duration": 0.8,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5886460596322304",
            "text": "Okay, what I will do is make arrangements with Karen's Boutique for you to exchange.",
            "from": {},
            "startTime": "2023-09-08T08:48:15.872Z",
            "endTime": "2023-09-08T08:48:20.272Z",
            "timeOffset": 86.3,
            "duration": 4.4,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5402188110364672",
            "text": "The Parker scarf at no additional cost.",
            "from": {},
            "startTime": "2023-09-08T08:48:20.272Z",
            "endTime": "2023-09-08T08:48:22.472Z",
            "timeOffset": 90.7,
            "duration": 2.2,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "6391700374421504",
            "text": "And in addition, I was able to look up your order in our system, and I am going to send out a special gift to you to make up for the inconvenience.",
            "from": {},
            "startTime": "2023-09-08T08:48:22.872Z",
            "endTime": "2023-09-08T08:48:30.972Z",
            "timeOffset": 93.3,
            "duration": 8.1,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "6037724000944128",
            "text": "Oh, excellent.",
            "from": {},
            "startTime": "2023-09-08T08:48:31.572Z",
            "endTime": "2023-09-08T08:48:32.272Z",
            "timeOffset": 102,
            "duration": 0.7,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "6538908944039936",
            "text": "Thank you so much.",
            "from": {},
            "startTime": "2023-09-08T08:48:32.272Z",
            "endTime": "2023-09-08T08:48:33.472Z",
            "timeOffset": 102.7,
            "duration": 1.2,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5916525547749376",
            "text": "You're welcome.",
            "from": {},
            "startTime": "2023-09-08T08:48:33.872Z",
            "endTime": "2023-09-08T08:48:34.672Z",
            "timeOffset": 104.3,
            "duration": 0.8,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "4562210107162624",
            "text": "And thank you for calling Parker scarf and I hope your wife enjoys your birthday gift.",
            "from": {},
            "startTime": "2023-09-08T08:48:34.672Z",
            "endTime": "2023-09-08T08:48:39.272Z",
            "timeOffset": 105.1,
            "duration": 4.6,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5322069077393408",
            "text": "Thank you.",
            "from": {},
            "startTime": "2023-09-08T08:48:39.672Z",
            "endTime": "2023-09-08T08:48:40.172Z",
            "timeOffset": 110.1,
            "duration": 0.5,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5682958142013440",
            "text": "Thank you very much.",
            "from": {},
            "startTime": "2023-09-08T08:48:40.172Z",
            "endTime": "2023-09-08T08:48:41.072Z",
            "timeOffset": 110.6,
            "duration": 0.9,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "5308401216389120",
            "text": "You're very welcome.",
            "from": {},
            "startTime": "2023-09-08T08:48:41.372Z",
            "endTime": "2023-09-08T08:48:42.472Z",
            "timeOffset": 111.8,
            "duration": 1.1,
            "conversationId": "5100189884088320",
            "phrases": []
        },
        {
            "id": "6432313358680064",
            "text": "Goodbye.",
            "from": {},
            "startTime": "2023-09-08T08:48:42.572Z",
            "endTime": "2023-09-08T08:48:42.972Z",
            "timeOffset": 113,
            "duration": 0.4,
            "conversationId": "5100189884088320",
            "phrases": []
        }
    ]
}